module.exports = __webpack_public_path__ + "img/mines.cb8e4ec9.png";